import React from "react";
import "./Common_Expert_Card.css";
import Common_Send_Button from "../common-send-button/Common_Send_Button";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";

const Common_Expert_Card = ({ data = {}, expert, onClick3, onClick4, onClick6 }) => {
  const {
    img,
    field,
    name,
    verified,
    location,
    experience,
    age,
    rating,
    availability,
    service,
  } = data;

  if (!img) return null;

  return (
    <div className="profile-card-wrapper">
      <div className="profile-card-body">
        <div className="profile-card-image">
          <img src={img} alt={field || "expert"} />
        </div>
        <div className="profile-card-info">
          <div className="profile-card-title">
            <span className="profile-card-name">{name}</span>
            {verified && (
              <img
                src="/assets/images/verified.png"
                alt="Verified"
                className="profile-card-badge"
              />
            )}
          </div>

          <div className="profile-card-location">{location}</div>
          <div className="profile-card-details">
            <div className="profile-card-row">
              <span className="profile-card-label">Field:-</span>
              <span className="profile-card-value">{field}</span>
            </div>

            <div className="profile-card-row">
              <span className="profile-card-label">Experience:-</span>
              <span className="profile-card-value">{experience}</span>
            </div>
            <div className="profile-card-row">
              <span className="profile-card-label">Age:-</span>
              <span className="profile-card-value">{age}</span>
            </div>
            <div className="profile-card-row">
              <span className="profile-card-label">Rating:-</span>
              <span className="profile-card-value">{rating}</span>
            </div>
          </div>
          <div className="status-link">
            <div className="profile-card-status">{availability}</div>
            <div className="profile-card-link">{service}</div>
          </div>
        </div>
      </div>
      <div className="buttons">
        <Common_Send_Button onClick3={onClick3} />
        <Common_Call_Button onClick4={onClick4} />
      </div>
    </div>

  );
};

export default Common_Expert_Card;

